import * as yup from "yup";
import "yup-phone-lite";

export const passwordRegExp = /^(?=.*[0-9])(?=.*[a-z])(?=.*[!@#$%^&*])/i; //Example !QAZse4rf
export const urlRegExp =
  /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()!@:%_\+.~#?&//=]*)/i;
export const phoneNumber = yup
  .string()
  .phone("US", "Номер телефону некоректный")
  .required("Номер повинен починатися на +380");

export const nameSchema = yup
  .string()
  .required("Ім'я не повинно бути порожнім");
export const emailSchema = yup
  .string()
  .required("Електронна пошта не повинна бути порожня")
  .email("Адреса електронної пошти вказана неправильно");

export const extraFields = yup
  .string()
  .required("Поле не повинно бути порожнім");

export const dateSchema = yup.date().typeError("Date cannot be a string");
export const timeSchema = yup.date().required("Time must be select");

export const contactNumber = yup.string().required("Contact is required");

export const roleSchema = yup.string().required();

export const employeeModalShema = yup.object().shape({
  name: nameSchema,
  surname: nameSchema,
  contactNumber: contactNumber,
  email: emailSchema,
});
